// extracted by mini-css-extract-plugin
module.exports = {"Brand":"brand_Brand__cAfDz"};